import React, { useEffect, useState, Fragment } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from "../home/header";
import SupplierItem from "./supplier_item";
import Login from "../home/login_form";
import { ApiClient } from "../../utils/api-client";
import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
import UTILS from "../../utils/commons";

const SupplierList = ( props ) => {
    var location = useLocation();
    let navigate = useNavigate();
    const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ suppliers, setSuppliers ] = useState( [] );
    const [ filteredSuppliers, setFilteredSuppliers ] = useState( suppliers );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( UTILS.DEFAULT_PAGE_SIZE );
    const [ totalPages, setTotalPages ] = useState( Math.ceil( filteredSuppliers.length / pageSize ) );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );
    const [ searchKeyword, setSearchKeyword ] = useState( "" );

    const applyFilter = ( list, keyword ) => {
        const normalized = keyword.trim().toLowerCase();
        if ( normalized.length === 0 ) {
            return list;
        }

        return list.filter( p =>
            ( p?.companyName || "" ).toLowerCase().includes( normalized ) ||
            ( p?.contactName || "" ).toLowerCase().includes( normalized ) ||
            ( p?.address || "" ).toLowerCase().includes( normalized ) ||
            ( p?.contactEmail || "" ).toLowerCase().includes( normalized ) ||
            ( p?.contactPhone || "" ).toLowerCase().includes( normalized )
        );
    }

    const loadSuppliers = async ( page = currentPage, limit = pageSize ) => {
        setLoading( true );
        try {
            const apiResponse = await apiClient.get( 'suppliers', { params: { page, limit } } );
            const suppliersData = apiResponse.data.data;
            setSuppliers( suppliersData );
            setFilteredSuppliers( applyFilter( suppliersData, searchKeyword ) );
            setTotalPages( apiResponse.data.totalPages );
            setCurrentPage( apiResponse.data.page );
            setHasNextPage( apiResponse.data.hasNextPage );
            setHasPreviousPage( apiResponse.data.hasPreviousPage );
            setPageSize( apiResponse.data.limit );
        }
        catch ( error ) {
            setSuppliers( [] );
            setFilteredSuppliers( [] );
            console.error( "Error fetching suppliers:", error );
        }
        setLoading( false );
    }
    useEffect( () => {
        loadSuppliers( 1, pageSize );
    }, [] );
    const confirmDelete = async ( itemId ) => {
        let message = "Are you sure you want to delete this supplier?";
        if ( window.confirm( message ) ) {

            await deleteSupplier( itemId )
        }
    }

    const deleteSupplier = async ( pid ) => {
        const response = await apiClient.delete( `suppliers/${pid}` );
        if ( response.status === 200 ) {
            //refresh list
            loadSuppliers( currentPage, pageSize );
        }
        else {
            alert( "Failed to delete supplier" );
        }
    }

    const handlePageChange = ( page ) => {
        if ( searchKeyword.trim().length > 0 ) return;
        loadSuppliers( page, pageSize );
    }
    const handlePageSizeChange = ( pageSize ) => {
        if ( searchKeyword.trim().length > 0 ) return;
        loadSuppliers( 1, pageSize );
    }

    if ( loginState ) {
        return ( <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container">
                    <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div>
                                <p className="text-sm uppercase tracking-wide text-gray-500">Procurement</p>
                                <p className="text-2xl font-semibold text-gray-800">Suppliers</p>
                            </div>
                            <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                                <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search suppliers..." value={searchKeyword} onChange={( e ) => {
                                    const keyword = e.target.value;
                                    setSearchKeyword( keyword );
                                    setFilteredSuppliers( applyFilter( suppliers, keyword ) );
                                }} />
                                <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/suppliers/new", { replace: true } )}>Add Supplier</button>
                            </div>
                        </div>
                    </div>
                    {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                        <div className="mt-12">{filteredSuppliers.length > 0 && searchKeyword.trim().length === 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                            <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">
                                {filteredSuppliers.length > 0 ? (
                                    filteredSuppliers.map( p => {
                                        return <SupplierItem data={p} key={p.id} onDelete={() => confirmDelete( p.id )} onClick={() => { navigate( "/suppliers/view/" + p.id, { replace: false, state: p } ) }} onEdit={() => { navigate( '/suppliers/edit/' + p.id, { replace: false, state: p } ) }} />
                                    } )
                                ) : <span className="text-start w-full py-8 px-4 text-gray-500">No data</span>
                                }
                            </div>
                        </div> )}
                </div>
            </section>
        </> )
    }
    else {
        return <Login target="/suppliers" />
    }
}
export default SupplierList;